import { type CharacteristicMeta as SchemaCharacteristicMeta } from '../schemas/CharacteristicMeta';
import { type CharacteristicMetaBatchUpdates as SchemaCharacteristicMetaBatchUpdates } from '../schemas/CharacteristicMetaBatchUpdates';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const UpdateCharacteristicsMetaBatchContentType = 'application/json' as const;
export type UpdateCharacteristicsMetaBatchRequest = SchemaCharacteristicMetaBatchUpdates;
export type UpdateCharacteristicsMetaBatchResponses = {
    /**
     * @description Successful update of data
     */
    '200': {
        'application/json': SchemaCharacteristicMeta[];
    };
};
export type UpdateCharacteristicsMetaBatchResponseSuccess =
    UpdateCharacteristicsMetaBatchResponses['200']['application/json'];
export type UpdateCharacteristicsMetaBatchSearchParams = undefined;
export type UpdateCharacteristicsMetaBatchPathParameters = undefined;
export const UpdateCharacteristicsMetaBatchUrl = '/characteristics/batch' as const;
export const UpdateCharacteristicsMetaBatchMethod = 'PATCH' as const;
export const getUpdateCharacteristicsMetaBatchUrl = (_params?: UpdateCharacteristicsMetaBatchPathParameters) =>
    UpdateCharacteristicsMetaBatchUrl;
